/**
 * SITE_TAB_IDS — the ONE canonical list of top-level site tab ids, in the
 * shipped funnel render order (Home leads, then Define → Analyze (optional) →
 * Decide, Roadmap last). The retired Path to GO hub (`pathtogo`) was removed
 * in Path to GO removal stage 3: its old `?tab=pathtogo` links are redirected
 * by SiteLandingPage (`legacyPathToGoRedirectTab`), and because the id is no
 * longer in the union, a leftover typed tab jump fails the type check.
 * Imported by SiteLandingPage (`Tab`
 * union + validity filtering), the Report Quality Guide (deep-link targets),
 * and their tests, so a tab rename/addition breaks loudly instead of
 * silently falling back to Home.
 *
 * CHUNK-SAFETY (R-104): this module must NEVER import anything — not the
 * store, not a component, not another lib. It is a pure const leaf shared by
 * the entry chunk (reportGuideSteps is eagerly imported via main.tsx) and the
 * siterag surfaces; adding an import here can re-introduce the chunk-level
 * leaf cycle that crashed /guide/reports in prod.
 */
export const SITE_TAB_IDS = [
  'home',
  'intent', 'map', 'documents', 'evidence',                // Define
  'simulations', 'generation', 'financial', 'supplychain', // Analyze
  'reports', 'decision', 'stakeholder', 'audit', 'deepdive', 'roadmap', // Decide
] as const;

export type SiteTabId = (typeof SITE_TAB_IDS)[number];

export function isSiteTabId(value: string): value is SiteTabId {
  return (SITE_TAB_IDS as readonly string[]).includes(value);
}
